import { useState } from 'react'
import S3Uploader from './S3Uploader'
import TunistryUploader from './TunistryUploader'
import '@uppy/core/dist/style.min.css'

export default function Upload() {

    const [uploader] = useState(() => new S3Uploader())

    return (
        <div className="UploadPage" style={{ padding: '1rem' }}>
            <TunistryUploader uploader={uploader} />
        </div>
    )
}